import React, { useRef } from 'react';
import { I18n } from '@aws-amplify/core';
import { Button, Divider, Input, InputRef, Skeleton } from 'antd';
import type { CustomSelectMultipleProps } from './types';
import * as S from './styles';

export function Multiple({
	placeholder = '',
	disabled = false,
	isSingle = false,
	isAdd = false,
	placeholderInput = '',
	textButton = '',
	loading = false,
	onInputChange = () => {},
	addItem = () => {},
	...props
}: Readonly<CustomSelectMultipleProps>): JSX.Element {
	const inputRef = useRef<InputRef>(null);

	function handleAddItem(e: React.MouseEvent<HTMLAnchorElement>) {
		addItem(e);

		if (inputRef.current?.input) {
			inputRef.current.input.value = '';
		}
	}

	return (
		<>
			{loading ? (
				<Skeleton.Button active />
			) : (
				<S.SelectMultipleWrapper
					{...props}
					disabled={disabled}
					placeholder={I18n.get(placeholder)}
					mode={isSingle ? undefined : 'tags'}
					dropdownRender={(menu) => (
						<>
							{menu}
							{isAdd && (
								<>
									<Divider style={{ margin: '8px 0' }} />
									<S.SpaceWrapper>
										<Input
											ref={inputRef}
											onChange={onInputChange}
											placeholder={I18n.get(placeholderInput)}
										/>
										<Button type="text" onClick={handleAddItem}>
											{I18n.get(textButton)}
										</Button>
									</S.SpaceWrapper>
								</>
							)}
						</>
					)}
				/>
			)}
		</>
	);
}
